/**
 * Box 5 of the ICS-201: the situation summary and health and safety briefing.
 *
 * The same record the Initial Response stepper's Overview writes, in the shadcn
 * editor the rest of the card uses. The stepper keeps its own Bootstrap editor,
 * so switching to Legacy shows the same text through the old controls.
 */

import React from 'react';

import {
  useIncidentInfo,
  useUpdateIcsInfo,
} from 'components/IAP/hooks/incidentInfoHooks';

import { useRecordIcs201Version } from '../ics201VersionRecording';
import SaveableField from '../SaveableField';

export const Ics201SituationBox: React.FC<{ disabled?: boolean }> = ({
  disabled,
}) => {
  const { data: incidentInfo } = useIncidentInfo();
  const incidentMutation = useUpdateIcsInfo();
  const recordVersion = useRecordIcs201Version();

  const save = (situationSummary: string) => {
    incidentMutation.mutate(
      {
        ...incidentInfo,
        situationSummary,
      } as Parameters<typeof incidentMutation.mutate>[0],
      { onSuccess: () => recordVersion() }
    );
  };

  return (
    <SaveableField
      id="ics201-situation-summary"
      label="Situation Summary and Health and Safety Briefing"
      hideLabel
      multiline
      rows={10}
      maxLength={4000}
      placeholder="Enter current situation details..."
      disabled={disabled}
      value={incidentInfo?.situationSummary ?? ''}
      onSave={save}
    />
  );
};

export default Ics201SituationBox;
